export default __webpack_public_path__ + "static/media/money-back@2x.4a703108.png";